import { decrypt } from "../../../shared/helpers/encoder";

export const FETCH_FOLLOWED_GOLFERS = "FETCH_FOLLOWED_GOLFERS";
export const FETCH_FOLLOWED_GOLFERS_SUCCESS = "FETCH_FOLLOWED_GOLFERS_SUCCESS";
export const FOLLOW_GOLFER = "FOLLOW_GOLFER";
export const FOLLOW_GOLFER_SUCCESS = "FOLLOW_GOLFER_SUCCESS";
export const UN_FOLLOW_GOLFER = "UN_FOLLOW_GOLFER";
export const UN_FOLLOW_GOLFER_SUCCESS = "UN_FOLLOW_GOLFER_SUCCESS";
export const RESET_FOLLOWED_GOLFERS = "RESET_FOLLOWED_GOLFERS";

export const fetchFollowedGolfers = (sortCriteria = undefined) => ({
  type: FETCH_FOLLOWED_GOLFERS,
  payload: { sortCriteria },
});

export const fetchFollowedGolfersSuccess = (payload, sortCriteria = null) => {
  const ordered =
    payload && sortCriteria
      ? payload.sort((a, b) => a[sortCriteria].localeCompare(b[sortCriteria]))
      : payload;

  return {
    type: FETCH_FOLLOWED_GOLFERS_SUCCESS,
    payload: ordered,
  };
};

export const followGolfer = (followed_golfer_id, club_id) => ({
  type: FOLLOW_GOLFER,
  payload: { followed_golfer_id: decrypt(followed_golfer_id), club_id },
});

export const followGolferSuccess = (payload) => ({
  type: FOLLOW_GOLFER_SUCCESS,
  payload,
});

export const unFollowGolfer = (followed_golfer_id, club_id) => ({
  type: UN_FOLLOW_GOLFER,
  payload: { followed_golfer_id: decrypt(followed_golfer_id), club_id },
});

export const unFollowGolferSuccess = (payload) => ({
  type: UN_FOLLOW_GOLFER_SUCCESS,
  payload,
});

export const resetFollowedGolfers = () => ({
  type: RESET_FOLLOWED_GOLFERS,
});
